//
// CardSeparator
//
import PropTypes from 'prop-types';

const CardSeparator = function CardSeparator(props) {
  const {
    horizontal,
    vertical,
  } = props;

  if (vertical) {
    return (
      <div className="shrink-0 py-10 w-0.5 h-full">
        <div className="w-full h-full bg-pxPrimary/10" />
      </div>
    );
  }

  if (horizontal) {
    return (
      <div className="shrink-0 px-10 h-0.5 w-full">
        <div className="w-full h-full bg-pxPrimary/10" />
      </div>
    );
  }

  return null;
};

CardSeparator.propTypes = {
  horizontal: PropTypes.bool,
  vertical: PropTypes.bool,
};

export default CardSeparator;
